import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout/Layout";
import SEO from "../components/SEO/seo";

export const pageQuery = graphql`
  query($firstId: String!, $secId: String!) {
    firstPlatform: contentfulPlatform(contentful_id: { eq: $firstId }) {
      name
      logo {
        url
      }
      cli
      contentful_id
      customUserRoles
      freePlanAvailable
      gdpr
      graphQlApi
      iso27001
      updatedAt(formatString: "MMMM DD, YYYY")
      restApi
      analyticsReporting
      backupAndDataRestoration
      builtInCmsdxp
      builtInDam
      bulkEditing
      customizableInterfaces
      dataEnrichment
      dataImportexportingCapabilities
      dataQualityManagement
      dataSecurity
      dataValidationsGovernance
      extensionsmarketplace
      factorAuthentication
      localizationTranslationManagement
      machCertified
      masterDataLinkingMatching
      masterDataManagementCapabilities
      openSource
      organizationManagement
      saas
      searchFiltering
      singleSignOn
      versionControl
      web2print
      webhook
      workflows
    }
    secPlatform: contentfulPlatform(contentful_id: { eq: $secId }) {
      name
      logo {
        url
      }
      cli
      contentful_id
      customUserRoles
      freePlanAvailable
      gdpr
      graphQlApi
      iso27001
      updatedAt(formatString: "MMMM DD, YYYY")
      restApi
      analyticsReporting
      backupAndDataRestoration
      builtInCmsdxp
      builtInDam
      bulkEditing
      customizableInterfaces
      dataEnrichment
      dataImportexportingCapabilities
      dataQualityManagement
      dataSecurity
      dataValidationsGovernance
      extensionsmarketplace
      factorAuthentication
      localizationTranslationManagement
      machCertified
      masterDataLinkingMatching
      masterDataManagementCapabilities
      openSource
      organizationManagement
      saas
      searchFiltering
      singleSignOn
      versionControl
      web2print
      webhook
      workflows
    }
    platforms: allContentfulPlatform(
      filter: { contentful_id: { nin: [$firstId, $secId] } }
    ) {
      nodes {
        name
        logo {
          url
        }
      }
    }
  }
`

const rows = [
  {
    id: "overview",
    name: "overview",
    type: "link",
  },
  {
    id: "Product Information Management",
    name: "Product Information Management",
    type: "heading",
  },
  {
    id: "bulkEditing",
    name: "Bulk Editing",
    type: "bool",
  },
  {
    id: "localizationTranslationManagement",
    name: "Localization & Translation Management",
    type: "bool",
  },
  {
    id: "dataImportexportingCapabilities",
    name: "Data import/Exporting Capabilities",
    type: "bool",
  },
  {
    id: "dataQualityManagement",
    name: "Data Quality Management",
    type: "bool",
  },
  {
    id: "workflows",
    name: "Workflows",
    type: "bool",
  },
  {
    id: "searchFiltering",
    name: "Search & Filtering",
    type: "bool",
  },
  {
    id: "dataEnrichment",
    name: "Data Enrichment",
    type: "bool",
  },
  {
    id: "masterDataLinkingMatching",
    name: "Master Data Linking & Matching",
    type: "bool",
  },
  {
    id: "dataValidationsGovernance",
    name: "Data Validations & Governance",
    type: "bool",
  },
  {
    id: "analyticsReporting",
    name: "Analytics & Reporting",
    type: "bool",
  },
  {
    id: "web2print",
    name: "Web2Print",
    type: "bool",
  },
  {
    id: "builtInDam",
    name: "Built-in DAM",
    type: "bool",
  },
  {
    id: "builtInCmsdxp",
    name: "Built-in CMS/DXP",
    type: "bool",
  },
  {
    id: "masterDataManagementCapabilities",
    name: "Master Data Management Capabilities",
    type: "bool",
  },
  {
    id: "versionControl",
    name: "Version Control",
    type: "bool",
  },
  {
    id: "dataSecurity",
    name: "Data Security",
    type: "bool",
  },
  {
    id: "Team management",
    name: "Team management",
    type: "heading",
  },
  {
    id: "customUserRoles",
    name: "Custom User Roles",
    type: "bool",
  },
  {
    id: "organizationManagement",
    name: "Organization Management",
    type: "bool",
  },
  {
    id: "customizableInterfaces",
    name: "Customizable Interfaces",
    type: "bool",
  },
  {
    id: "Developer Experience & API Connectivity",
    name: "Developer Experience & API Connectivity",
    type: "heading",
  },
  {
    id: "restApi",
    name: "REST API",
    type: "bool",
  },
  {
    id: "graphQlApi",
    name: "GraphQL API",
    type: "bool",
  },
  {
    id: "webhook",
    name: "Webhook",
    type: "bool",
  },
  {
    id: "cli",
    name: "CLI",
    type: "bool",
  },
  {
    id: "machCertified",
    name: "MACH Certified",
    type: "bool",
  },
  {
    id: "SECURITY AND COMPLIANCE",
    name: "Security and Compliance",
    type: "heading",
  },
  {
    id: "singleSignOn",
    name: "Single Sign On",
    type: "bool",
  },
  {
    id: "factorAuthentication",
    name: "2-Factor Authentication",
    type: "bool",
  },
  {
    id: "gdpr",
    name: "GDPR",
    type: "bool",
  },
  {
    id: "iso27001",
    name: "ISO27001",
    type: "bool",
  },
  {
    id: "pricing",
    name: "Pricing Model",
    type: "heading",
  },
  {
    id: "freePlanAvailable",
    name: "Free Plan Available",
    type: "bool",
  },
  {
    id: "openSource",
    name: "Open Source",
    type: "bool",
  },
  {
    id: "saas",
    name: "SAAS",
    type: "bool",
  },
  {
    id: "others",
    name: "Others",
    type: "heading",
  },
  {
    id: "extensionsmarketplace",
    name: "Extensions/Marketplace",
    type: "bool",
  },
  {
    id: "backupAndDataRestoration",
    name: "Backup and Data restoration",
    type: "bool",
  },
  {
    id: "updatedAt",
    name: "Last update",
    type: "footer",
  },
]

const slugify = str =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // replace non-alphanumeric characters with dashes
    .replace(/^-+|-+$/g, "");    // trim leading/trailing dashes

// Temporary: store platform names in query string
let first = ""
let second = ""

if (typeof window !== "undefined") {
  const path = window.location.pathname.replace(/^\/|\/$/g, "")
  const parts = path.split("-vs-")
  if (parts.length === 2) {
    first = slugify(parts[0])
    second = slugify(parts[1])
    const [canonicalFirst, canonicalSecond] = [first, second].sort()
    const canonicalPath = `/${canonicalFirst}-vs-${canonicalSecond}/`
    if (`/${path}/` !== canonicalPath) {
      window.location.replace(canonicalPath)
    }
  }
}


const formatList = (arr: string[]): string => {
  if (arr.length <= 2) return arr.join(" and ");
  return arr.slice(0, -1).join(", ") + ", and " + arr[arr.length - 1];
};

const getHashIndex = (a: string, b: string, max: number): number => {
  const str = [a.toLowerCase(), b.toLowerCase()].sort().join("-");
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return Math.abs(hash) % max;
};

const shuffleDeterministic = (arr, seed) => {
  const cloned = [...arr];
  let m = cloned.length, t, i;

  let hash = seed;
  while (m) {
    i = Math.floor(Math.abs(Math.sin(hash++)) * m--);
    t = cloned[m];
    cloned[m] = cloned[i];
    cloned[i] = t;
  }

  return cloned;
};



const templates = [
  (a, b, features) => `Compare ${a} vs ${b} on ${features}.`,
  (a, b, features) => `${a} and ${b} go head-to-head on ${features}.`,
  (a, b, features) => `Explore the strengths of ${a} vs ${b} in ${features}.`,
  (a, b, features) => `Key PIM features compared: ${a} vs ${b} – ${features}.`,
  (a, b, features) => `Which is better: ${a} or ${b}? Compare ${features}.`,
  (a, b, features) => `Detailed PIM feature comparison: ${a} vs ${b} on ${features}.`,
  (a, b, features) => `How do ${a} and ${b} compare on ${features}? Find out here.`,
  (a, b, features) => `Side-by-side comparison of ${a} and ${b} covering ${features}.`,
  (a, b, features) => `${features} — see how ${a} stacks up against ${b}.`,
  (a, b, features) => `Feature breakdown: ${a} vs ${b} on ${features}.`,
  (a, b, features) => `PIM showdown: ${a} or ${b}? Compare ${features}.`,
  (a, b, features) => `${a} vs ${b}: compare key capabilities like ${features}.`,
];


const getFeatureHighlights = (first, second, rows, templateIndex: number): string => {
  const features = rows.filter(r => r.type === "bool");

  const visible = features.filter(f => first[f.id] || second[f.id]);
  const common = visible.filter(f => first[f.id] && second[f.id]);
  const diff = visible.filter(f => first[f.id] !== second[f.id]);

  // Combine and shuffle deterministically using the same index
  const allCandidates = [...common, ...diff];
  const shuffled = shuffleDeterministic(allCandidates, templateIndex);

  const selectedFeatureNames = shuffled
    .slice(0, 4)
    .map(f => f.name);

  const selected = formatList(selectedFeatureNames);

  const template = templates[templateIndex];
  return template(first.name, second.name, selected);
};



export default function ComparisonPage({
  data: { firstPlatform, secPlatform, platforms },
}) {
  React.useEffect(() => window.scrollTo(0, 0), [])
  const templateIndex = getHashIndex(firstPlatform.name, secPlatform.name, templates.length);
  const metaDescription = getFeatureHighlights(firstPlatform, secPlatform, rows, templateIndex);


  return (
    <Layout consultationBackgroundColorGrey={true}>
      <SEO
        title={`${firstPlatform.name} vs ${secPlatform.name}`}
        description={metaDescription}
      />
      <section className="container !max-w-[71.25rem] mx-auto px-4 py-12">
        <b className="text-hamariBlue">COMPARISON OF</b>
        <h1 className="my-4 text-[2.5rem] leading-[1.2]">
          {firstPlatform.name.toUpperCase()} vs {secPlatform.name.toUpperCase()}
        </h1>
        <table
          className="my-5 table table-striped text-[0.75em] word-break w-full text-left"
        >
          <thead>
            <tr>
              <th
                className="sticky top-5 bg-hamariWhite shadow-lg !border-t-0 p-4 pb-4 text-[1.125em]"
              >
                FEATURE
              </th>
              <th className="sticky top-5 bg-hamariWhite shadow-lg !border-t-0 text-center p-4">
                <div
                  className="flex items-center justify-center py-2 max-h-12"
                >
                  <img
                    src={firstPlatform.logo?.url}
                    className="compare-img" alt="compare"
                  />
                </div>
              </th>
              <th className="sticky top-5 bg-hamariWhite shadow-lg !border-t-0 text-center p-4">
                <div
                  className="flex items-center justify-center py-2 max-h-12"
                >
                  <img
                    src={secPlatform.logo?.url}
                    className="compare-img" alt="compare"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map(({ id, name, type }) => {
              if (type == "heading") {
                return (
                  <tr key={id} className="header-light border-t border-[#e0e0e0]">
                    <th colSpan={3} className="pt-12">
                      {name}</th>
                  </tr>
                )
              } else if (type == "footer") {
                return (
                  <tr key={id} className="bg-white">
                    <td className="py-4 px-3 !border-t-0 text-dark">{name}</td>
                    <td align="center" className="p-4 !border-t-0 text-dark">
                      {firstPlatform[id]}
                    </td>
                    <td align="center" className="p-4 !border-t-0 text-dark">
                      {secPlatform[id]}
                    </td>
                  </tr>
                )
              } else
                return (
                  <tr key={id}>
                    <td className="p-4">{name}</td>
                    <td
                      align="center"
                      className="border-[#e0e0e0] !border-t-0 border-l p-4"
                    >
                      {type == "link" ? (
                        <a
                          href={`/pim/${slugify(firstPlatform.name)}/`}
                          className="btn btn-custom inline-block rounded-full !py-[.25rem] !px-2 lg:!py-2 lg:!px-12 text-[1.125em]"
                        >
                          Learn more
                        </a>
                      ) : type == "bool" ? (
                        <b>
                          {firstPlatform[id] ? (
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 49 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M49 24.4822C49.0457 37.9843 38.1117 48.9594 24.5761 49C11.0456 49.0406 0.0659782 38.1517 4.98699e-05 24.6243C-0.0658785 11.0868 10.9644 0 24.5051 0C37.9951 0 48.9544 10.9498 49 24.4822ZM21.4572 38.3242C27.8979 31.388 34.2017 24.5939 40.5511 17.7541C38.8724 16.1963 37.3358 14.7705 35.7535 13.2991C30.7176 18.7181 25.8186 23.9951 20.8638 29.3279C18.5006 27.3846 16.2489 25.5376 13.9211 23.6247C12.5214 25.3245 11.1825 26.9533 9.75745 28.6835C13.6624 31.9005 17.5066 35.0667 21.4623 38.3242H21.4572Z"
                                fill="#FDA209"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M24.9715 50C11.1652 49.9897 -0.00517686 38.8164 1.79992e-06 25.013C0.00518046 11.2251 11.1911 0.0259326 24.9819 4.46475e-05C38.8244 -0.0258433 50.0311 11.2095 50.0052 25.0958C49.9793 38.9096 38.8244 50.0104 24.9715 50ZM36.5769 17.9508C34.9663 16.3095 33.4593 14.7821 31.8125 13.0993C29.5391 15.4293 27.1932 17.8265 24.7851 20.2962C22.32 17.811 19.9586 15.4241 17.7369 13.1874C16.0798 14.808 14.5262 16.3353 12.8172 18.0129C15.1269 20.3014 17.5091 22.6572 20.1864 25.3081C17.7059 27.6691 15.2512 30.0042 13.0554 32.0959C14.6504 33.7217 16.1523 35.2491 17.8664 36.9939C20.1346 34.7106 22.4909 32.3341 24.9922 29.8074C27.333 32.1736 29.6893 34.5605 31.9679 36.8645C33.5474 35.2853 35.0596 33.7683 36.8307 31.9924C34.464 29.7194 32.0145 27.3688 29.5028 24.956C31.9731 22.5122 34.3294 20.1771 36.5821 17.9456L36.5769 17.9508Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </b>
                      ) : (
                        <b>{firstPlatform[id]}</b>
                      )}
                    </td>
                    <td
                      align="center"
                      className="border-[#e0e0e0] !border-t-0 border-l p-4"
                    >
                      {type == "link" ? (
                        <a
                          href={`/pim/${slugify(secPlatform.name)}/`}
                          className="btn btn-custom inline-block rounded-full !py-[.25rem] !px-2 lg:!py-2 lg:!px-12 text-[1.125em]"
                        >
                          Learn more
                        </a>
                      ) : type == "bool" ? (
                        <b>
                          {secPlatform[id] ? (
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 49 49"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M49 24.4822C49.0457 37.9843 38.1117 48.9594 24.5761 49C11.0456 49.0406 0.0659782 38.1517 4.98699e-05 24.6243C-0.0658785 11.0868 10.9644 0 24.5051 0C37.9951 0 48.9544 10.9498 49 24.4822ZM21.4572 38.3242C27.8979 31.388 34.2017 24.5939 40.5511 17.7541C38.8724 16.1963 37.3358 14.7705 35.7535 13.2991C30.7176 18.7181 25.8186 23.9951 20.8638 29.3279C18.5006 27.3846 16.2489 25.5376 13.9211 23.6247C12.5214 25.3245 11.1825 26.9533 9.75745 28.6835C13.6624 31.9005 17.5066 35.0667 21.4623 38.3242H21.4572Z"
                                fill="#FDA209"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 50 50"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M24.9715 50C11.1652 49.9897 -0.00517686 38.8164 1.79992e-06 25.013C0.00518046 11.2251 11.1911 0.0259326 24.9819 4.46475e-05C38.8244 -0.0258433 50.0311 11.2095 50.0052 25.0958C49.9793 38.9096 38.8244 50.0104 24.9715 50ZM36.5769 17.9508C34.9663 16.3095 33.4593 14.7821 31.8125 13.0993C29.5391 15.4293 27.1932 17.8265 24.7851 20.2962C22.32 17.811 19.9586 15.4241 17.7369 13.1874C16.0798 14.808 14.5262 16.3353 12.8172 18.0129C15.1269 20.3014 17.5091 22.6572 20.1864 25.3081C17.7059 27.6691 15.2512 30.0042 13.0554 32.0959C14.6504 33.7217 16.1523 35.2491 17.8664 36.9939C20.1346 34.7106 22.4909 32.3341 24.9922 29.8074C27.333 32.1736 29.6893 34.5605 31.9679 36.8645C33.5474 35.2853 35.0596 33.7683 36.8307 31.9924C34.464 29.7194 32.0145 27.3688 29.5028 24.956C31.9731 22.5122 34.3294 20.1771 36.5821 17.9456L36.5769 17.9508Z"
                                fill="black"
                              />
                            </svg>
                          )}
                        </b>
                      ) : (
                        <b>{secPlatform[id]}</b>
                      )}
                    </td>
                  </tr>
                )
            })}
          </tbody>
        </table>
      </section>
      <section className="container !max-w-[71.25rem] mx-auto container-xxl px-4 mt-4 !mb-12">
        <div className="!lg:text-[2rem] font-bold">COMPARE {firstPlatform.name.toUpperCase()} WITH</div>
        <div className="flex flex-wrap items-center my-4">
          {platforms.nodes.map(({ name, logo }) => (
            <a
              href={`/${slugify(firstPlatform.name)}-vs-${slugify(name)}/`}
              className="w-full md:w-auto btn border-[#e7e7e7] border rounded-sm py-2 md:py-[.375rem] px-[.75rem] md:px-12 mt-4 mr-4 flex items-center"
              key={name}
            >
              <picture className="inline-block mx-auto">
                <source media="(min-width: 768px)" srcSet={logo?.url} />
                <img
                  src={logo?.url}
                  alt="Logo"
                  className="object-contain h-[3rem] w-[9rem]"
                />
              </picture>
              <span className="sr-only hidden">{`${name} vs ${firstPlatform.name}`}</span>
            </a>
          ))}
        </div>
      </section>
    </Layout>
  )
}